import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { LanguageProvider } from './i18n.jsx'
import { registerServiceWorker } from './pwa'

// Outside the router, so the sign-in screen is in the right language too -- somebody who cannot get
// in yet is exactly the person least able to cope with a language they do not read.
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </StrictMode>,
)

registerServiceWorker()
